"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.knowledge.base': 'Base de Conocimientos',
    'onboarding.knowledge.title': 'Base de Conocimientos (Opcional)',
    'onboarding.knowledge.description': 'Agregue entradas de conocimiento para mejorar la experiencia y respuestas de su avatar.',
    'onboarding.knowledge.final.step': 'Paso Final - Carga de Conocimientos',
    'onboarding.knowledge.label': 'Seleccionar Entradas de Conocimiento',
    'onboarding.knowledge.placeholder': 'Busque y seleccione entradas de conocimiento para su avatar...',
    'onboarding.knowledge.skip.info': 'Puede omitir este paso y agregar entradas de conocimiento más tarde si es necesario.',
    'onboarding.knowledge.selected.single': 'entrada de conocimiento seleccionada',
    'onboarding.knowledge.selected.multiple': 'entradas de conocimiento seleccionadas',
    'onboarding.knowledge.bonus': 'Conocimiento agregado',
    'onboarding.knowledge.items': 'Elementos de Conocimiento',
};
